import { NgClass } from '@angular/common'
import {
  AfterContentInit,
  Component,
  ContentChild,
  Directive,
  Input,
} from '@angular/core'
import { SvgIconComponent } from 'angular-svg-icon'

export type AlertTypes = 'error' | 'info' | 'notice' | 'success' | 'warning'

export type AlertSizes = 'default' | 'small' | 'large'

@Directive({
  selector: '[alertTitle]',
  standalone: true,
})
export class AlertTitleDirective {}

@Directive({
  selector: '[alertBody]',
  standalone: true,
})
export class AlertBodyDirective {}

@Component({
  selector: 'app-alert',
  imports: [NgClass, SvgIconComponent],
  templateUrl: './alert.component.html',
})
export class AlertComponent implements AfterContentInit {
  @Input() public type: AlertTypes = 'info'
  @Input() public size: AlertSizes = 'default'
  @Input() public showIcon: boolean = false
  @Input() public icon?: string

  @ContentChild(AlertTitleDirective)
  private readonly titleTpl?: AlertTitleDirective
  public hasTitle: boolean = false

  @ContentChild(AlertBodyDirective)
  private readonly bodyTpl?: AlertBodyDirective
  public hasBody: boolean = false

  public ngAfterContentInit(): void {
    this.hasTitle = !!this.titleTpl
    this.hasBody = !!this.bodyTpl
  }

  public get iconSrc(): string {
    return this.icon || this.getDefaultIcon()
  }

  private getDefaultIcon(): string {
    switch (this.type) {
      case 'error':
        return 'assets/icons/Alerts_feedback/alert-circle.svg'
      case 'success':
        return 'assets/icons/General/check-circle.svg'
      case 'warning':
        return 'assets/icons/Alerts_feedback/alert-triangle.svg'
      case 'info':
        return 'assets/icons/Alerts_feedback/alert-circle.svg'
      case 'notice':
        return 'assets/icons/Alerts_feedback/alert-circle.svg'
    }
  }
}
